// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/feedback._index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/feedback._index.tsx");
  import.meta.hot.lastModified = "1752744841902.5198";
}
// REMIX HMR END

import { redirect } from "@remix-run/node";
import { Form, Link, useActionData, useLoaderData, useSubmit } from "@remix-run/react";
import { useState } from "react";
import StarRating from "~/components/starRating";
import Stepper from "~/components/stepper";
import { createFeedback, getKursListItems, getKursleitungListItems, sendEmailToAdmin, sendEmailToKursleitung } from "~/models/feedback.server";
import { validateEmail } from "~/utils";
export const loader = async ({
  request
}) => {
  const kursListItems = await getKursListItems();
  const kursleitungListItems = await getKursleitungListItems();
  return {
    kursListItems,
    kursleitungListItems
  };
};
export async function action({
  request
}) {
  const dataForm = await request.formData();
  const values = Object.fromEntries(dataForm.entries());
  const feedback = await createFeedback({
    ...values,
    kursleitung_id: parseInt(String(values.kursleitung_id)),
    kurs_id: parseInt(String(values.kurs_id)),
    useMyData: !values.useMyData ? false : true,
    contactMe: !values.contactMe ? false : true
  });
  if (feedback) {
    sendEmailToKursleitung(feedback.kursleitung_id);
    if (feedback.useMyData) {
      sendEmailToAdmin(feedback);
    }
  }
  return redirect(`/feedback/done`);
}
export const meta = () => [{
  title: "Feedback"
}];
export default function FeedbackPage() {
  _s();
  const {
    kursListItems,
    kursleitungListItems
  } = useLoaderData();
  const [dataForm, setDataForm] = useState({});
  const [dsgvo, setDsgvo] = useState(false);
  const actionData = useActionData();
  const submit = useSubmit();
  const [currentStep, setCurrentStep] = useState(0);
  const steps = ["Kurs", "Kursleitung", "Inhalt", "GSP-Schulungsportal", "Seminarbewertung insgesamt", "Freiwillige Angaben"];
  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };
  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
  };
  return <div className="flex min-h-full flex-col justify-center">
      <div className="mx-auto w-full md:max-w-[80%] px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 h-full justify-center items-center">
          <div className="col-span-1 hidden md:block">
            <a href="https://gsp-network.com/">
              <img src="gsp-network-logo.png" alt="Logo" className="mx-auto w-full max-w-[26rem] md:max-w-[30rem] p-10" />
            </a>
            <a href="../">
              <p className="text-center text-3xl font-bold text-[#083d77] pb-6">
                Feedback Fragebogen
              </p>
            </a>
            <Stepper steps={steps} currentStep={currentStep} />
          </div>
          <div className="col-span-2 md:p-4">
            <Form method="post" className="space-y-6" onSubmit={e => {
            e.preventDefault();
            var formData = new FormData();
            for (var key in dataForm) {
              formData.append(key, dataForm[key]);
            }
            submit(formData, {
              method: "post"
            });
          }}>
              {currentStep === 0 && <div>
                  <p className="block text-4xl mt-8 font-medium text-gray-700">
                    Kurs
                  </p>
                  <hr className="pb-5"></hr>
                  <label htmlFor="kursname" className="block text-2xl font-medium text-gray-700 pb-5">
                    Kurs wählen
                  </label>
                  <ul className="grid w-full gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {kursListItems.map(kurs => <li key={kurs.id}>
                        <input type="radio" onChange={val => setDataForm({
                    ...dataForm,
                    kurs_id: parseInt(val.currentTarget.value)
                  })} checked={kurs.id === dataForm?.kurs_id} name="kurs_id" id={kurs.name} value={kurs.id} className="hidden" required />
                        <label htmlFor={kurs.name} className={`inline-flex items-center justify-between w-full p-2 bg-white border rounded-lg cursor-pointer focus:border-[#cc5631] focus:text-[#cc5631] hover:text-gray-600 hover:bg-gray-100 ${kurs.id === parseInt(dataForm?.kurs_id) ? "text-[#cc5631] border-[#cc5631]" : "text-gray-500 border-gray-200"}`}>
                          <div className="block w-3/4">
                            <div className="w-full text-sm overflow-hidden">{kurs.name}</div>
                          </div>

                          <svg className="w-3 fill-current" xmlns="http://www.w3.org/2000/svg" id="Ebene_2" dataform-name="Ebene 2" viewBox="0 0 90.09 249.17"><g id="Ebene_1-2" dataform-name="Ebene 1"><polygon className="cls-1" points="90.09 129.81 90.09 119.54 20.83 0 1.71 0 0 1.71 0 10.28 1.71 13.7 58.45 112.23 2.26 112.23 0 114.49 0 134.67 2.26 136.93 58.62 136.93 1.89 235.47 .18 238.89 .18 247.45 1.89 249.17 21.01 249.17 90.09 129.81"></polygon></g></svg>
                        </label>
                      </li>)}

                  </ul>
                  <div className="flex justify-between pt-10">
                    <Link to="../" className="flex items-center justify-center border border-transparent bg-[#083d78] px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-[#de782d] sm:px-8">
                      Startseite
                    </Link>
                    <button onClick={handleNext} disabled={!dataForm.kurs_id} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 ${!dataForm.kurs_id ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#083d78] hover:bg-[#de782d]'}`}>
                      weiter
                    </button>
                  </div>
                </div>}
              {currentStep === 1 && <div className="space-y-4">
                  <div className="pb-2">
                    <p className="block text-4xl mt-8 font-medium text-gray-700 text-center: md:text-left">
                      Kursleitung
                    </p>
                    <hr className="pb-5"></hr>
                    <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                      <p className="w-full block text-sm text-gray-700 ">
                        Kursleitung wählen
                      </p>
                      <select name="kursleitung_id" id="kursleitung_id" defaultValue={dataForm.kursleitung_id?.toString() || ""} onChange={el => setDataForm({
                    ...dataForm,
                    kursleitung_id: parseInt(el.currentTarget.value)
                  })} className="w-full cursor-pointer block p-2.5 text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631] text-gray-700">
                        <option disabled value="">Bitte wählen</option>
                        {kursleitungListItems.map(kursleitung => <option key={kursleitung.id} value={kursleitung.id}>{kursleitung.name + ", " + kursleitung.surname}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Die Kursleitung war gut vorbereitet
                    </p>
                    <StarRating name="kursleitung_1" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Die Kursleitung war fachlich kompetent
                    </p>
                    <StarRating name="kursleitung_2" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Die Kursleitung hat den Seminarinhalt verständlich und im angemessenen Tempo vermittelt
                    </p>
                    <StarRating name="kursleitung_3" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Ich wurde ausreichend mit verständlichen Unterlagen versorgt
                    </p>
                    <StarRating name="kursleitung_4" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="flex justify-between pt-10">
                    <button onClick={handlePrev} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 bg-[#083d78] hover:bg-[#de782d]`}>
                      zurück
                    </button>
                    <button onClick={handleNext} disabled={!(dataForm.kursleitung_id && dataForm.kursleitung_1 && dataForm.kursleitung_2 && dataForm.kursleitung_3 && dataForm.kursleitung_4)} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 ${!(dataForm.kursleitung_id && dataForm.kursleitung_1 && dataForm.kursleitung_2 && dataForm.kursleitung_3 && dataForm.kursleitung_4) ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#083d78] hover:bg-[#de782d]'}`}>
                      weiter
                    </button>
                  </div>
                </div>}
              {currentStep === 2 && <div className="space-y-4">
                  <div className="pb-2">
                    <p className="block text-4xl mt-8 font-medium text-gray-700 ">
                      Inhalt
                    </p>
                    <hr className="pb-5"></hr>
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Das Seminar ist fachlich für meine tägliche Arbeit von Nutzen
                    </p>
                    <StarRating name="inhalt_1" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Der Umfang des vermittelten Stoffes war angemessen
                    </p>
                    <StarRating name="inhalt_2" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Der Seminaraufbau war gut gegliedert
                    </p>
                    <StarRating name="inhalt_3" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="flex justify-between pt-10">
                    <button onClick={handlePrev} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 bg-[#083d78] hover:bg-[#de782d]`}>
                      zurück
                    </button>
                    <button onClick={handleNext} disabled={!(dataForm.inhalt_1 && dataForm.inhalt_2 && dataForm.inhalt_3)} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 ${!(dataForm.inhalt_1 && dataForm.inhalt_2 && dataForm.inhalt_3) ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#083d78] hover:bg-[#de782d]'}`}>
                      weiter
                    </button>
                  </div>
                </div>}
              {currentStep === 3 && <div className="space-y-4">
                  <div className="pb-2">
                    <p className="block text-4xl mt-8 font-medium text-gray-700">
                      GSP-Schulungsportal
                    </p>
                    <hr className="pb-5"></hr>
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Die Struktur des Portals ist übersichtlich
                    </p>
                    <StarRating name="schulungsportal_1" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Das Portal ist ansprechend und zeitgemäß gestaltet
                    </p>
                    <StarRating name="schulungsportal_2" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Infos und Anweisungen auf dem Portal sind verständlich formuliert
                    </p>
                    <StarRating name="schulungsportal_3" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Ich habe die Schulungsunterlagen schnell gefunden
                    </p>
                    <StarRating name="schulungsportal_4" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="flex justify-between pt-10">
                    <button onClick={handlePrev} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 bg-[#083d78] hover:bg-[#de782d]`}>
                      zurück
                    </button>
                    <button onClick={handleNext} disabled={!(dataForm.schulungsportal_1 && dataForm.schulungsportal_2 && dataForm.schulungsportal_3 && dataForm.schulungsportal_4)} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 ${!(dataForm.schulungsportal_1 && dataForm.schulungsportal_2 && dataForm.schulungsportal_3 && dataForm.schulungsportal_4) ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#083d78] hover:bg-[#de782d]'}`}>
                      weiter
                    </button>
                  </div>
                </div>}
              {currentStep === 4 && <div className="space-y-4">
                  <div className="pb-2">
                    <p className="block text-4xl mt-8 font-medium text-gray-700">
                      Seminarbewertung insgesamt
                    </p>
                    <hr className="pb-5"></hr>
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left py-4">
                    <p className="block text-sm text-gray-700">
                      Wie hat Ihnen das Seminar insgesamt gefallen?
                    </p>
                    <StarRating name="seminarbewertung" dataForm={dataForm} setDataForm={setDataForm} />
                  </div>
                  <div className="md:flex flex-col text-center md:text-left">
                    <p className="block text-sm text-gray-700">
                      Gut gefallen hat mir...
                    </p>
                    <textarea id="gefallen_hat" name="gefallen_hat" maxLength={1000} defaultValue={dataForm.gefallen_hat || ""} onChange={el => setDataForm({
                  ...dataForm,
                  gefallen_hat: el.currentTarget.value
                })} rows={3} className="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631] text-gray-700" placeholder="Ihre Antwort..."></textarea>
                    <p className="block text-xs text-gray-700 text-right">
                      {dataForm?.gefallen_hat?.length | 0}/1000
                    </p>
                  </div>
                  <div className="md:flex flex-col text-center md:text-left">
                    <p className="block text-sm text-gray-700">
                      Meine Optimierungsvorschläge...
                    </p>
                    <textarea id="optimierungsvorschlag" name="optimierungsvorschlag" maxLength={800} defaultValue={dataForm.optimierungsvorschlag || ""} onChange={el => setDataForm({
                  ...dataForm,
                  optimierungsvorschlag: el.currentTarget.value
                })} rows={3} className="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631]  text-gray-700 " placeholder="Ihre Antwort..."></textarea>
                    <p className="block text-xs text-gray-700 text-right">
                      {dataForm?.optimierungsvorschlag?.length | 0}/1000
                    </p>
                  </div>
                  <div className="md:flex flex-col text-center md:text-left">
                    <p className="block text-sm text-gray-700">
                      Welche Seminarinhalte könnten für Ihr Team im Rahmen von Schulungen zukünftig interessant sein?
                    </p>
                    <textarea id="seminarinhalte" name="seminarinhalte" maxLength={800} defaultValue={dataForm.seminarinhalte || ""} onChange={el => setDataForm({
                  ...dataForm,
                  seminarinhalte: el.currentTarget.value
                })} rows={3} className="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631]   text-gray-700 " placeholder="Ihre Antwort..."></textarea>
                    <p className="block text-xs text-gray-700 text-right">
                      {dataForm?.seminarinhalte?.length | 0}/1000
                    </p>
                  </div>
                  <div className="md:flex justify-center md:justify-between items-center text-center md:text-left md:py-2">
                    <p className="block text-sm text-gray-700">
                      Wie sind Sie auf unsere Schulungen aufmerksam geworden?
                    </p>
                    <select name="aufmerksam_durch" id="aufmerksam_durch" defaultValue={dataForm.aufmerksam_durch || ""} onChange={el => setDataForm({
                  ...dataForm,
                  aufmerksam_durch: el.currentTarget.value
                })} className="w-full overflow-hidden cursor-pointer block p-2.5 text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631]   text-gray-700 ">
                      <option disabled value="">Bitte wählen</option>
                      <option value="Newsletter">Über die Newsletter</option>
                      <option value="Internetrecherche">Durch Internetrecherche</option>
                      <option value="Weiterempfehlung">Über Weiterempfehlung</option>
                      <option value="Weiterbildungsmaßnahme Arbeitgeber">Es ist eine Weiterbildungsmaßnahme des Arbeitgebers</option>
                    </select>
                  </div>
                  <div className="flex justify-between pt-10">
                    <button onClick={handlePrev} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 bg-[#083d78] hover:bg-[#de782d]`}>
                      zurück
                    </button>
                    <button onClick={handleNext} disabled={!(dataForm.seminarbewertung && dataForm.aufmerksam_durch)} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 ${!(dataForm.seminarbewertung && dataForm.aufmerksam_durch) ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#083d78] hover:bg-[#de782d]'}`}>
                      weiter
                    </button>
                  </div>
                </div>}
              {currentStep === 5 && <div className="space-y-4">
                  <div className="pb-2 text-center md:text-left">
                    <p className="block text-4xl mt-8 font-medium text-gray-700 ">
                      Freiwillige Angaben
                    </p>
                    <hr className="pb-5"></hr>
                  </div>
                  <div className="pb-2 text-center md:text-left">
                    <p className="block text-sm mt-8 font-medium text-gray-700 ">
                      Hier haben Sie die Möglichkeit, Ihre Kontaktdaten zu hinterlassen, falls Sie bei offenen Fragen oder Anliegen den persönlich Kontakt mit uns wünschen.                    </p>
                    <hr className="pb-5"></hr>
                  </div>
                  <div className="md:flex flex-col text-center md:text-left">
                    <p className="block text-sm text-gray-700">
                      Vorname, Nachname
                    </p>
                    <input type="text" id="name" name="name" maxLength={100} defaultValue={dataForm.name || ""} onChange={el => setDataForm({
                  ...dataForm,
                  name: el.currentTarget.value
                })} className="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631]   text-gray-700 " placeholder="Vorname, Nachname" />
                    <p className="block text-xs text-gray-700 text-right">
                      {dataForm?.name?.length | 0}/100
                    </p>
                  </div>
                  <div className="md:flex flex-col text-center md:text-left">
                    <p className="block text-sm text-gray-700">
                      Unternehmen
                    </p>
                    <input type="text" id="company" name="company" maxLength={100} defaultValue={dataForm.company || ""} onChange={el => setDataForm({
                  ...dataForm,
                  company: el.currentTarget.value
                })} className="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631]   text-gray-700 " placeholder="Unternehmen" />
                    <p className="block text-xs text-gray-700 text-right">
                      {dataForm?.company?.length | 0}/100
                    </p>
                  </div>
                  <div className="md:flex flex-col text-center md:text-left">
                    <p className="block text-sm text-gray-700">
                      E-Mail
                    </p>
                    <input type="text" id="email" name="email" maxLength={100} defaultValue={dataForm.email || ""} onChange={el => setDataForm({
                  ...dataForm,
                  email: el.currentTarget.value
                })} className="block p-2.5 w-full text-sm rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631]   text-gray-700 " placeholder="E-Mail" />
                    <p className="block text-xs text-gray-700 text-right">
                      {dataForm?.email?.length | 0}/100
                    </p>
                  </div>
                  <div className="md:flex flex-col text-center md:text-left">
                    <p className="block text-sm text-gray-700">
                      Telefon
                    </p>
                    <input type="text" id="phone" name="phone" maxLength={100} defaultValue={dataForm.phone || ""} onChange={el => setDataForm({
                  ...dataForm,
                  phone: el.currentTarget.value
                })} className="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-[#cc5631] focus:border-[#cc5631]   text-gray-700 " placeholder="Telefon" />
                    <p className="block text-xs text-gray-700 text-right">
                      {dataForm?.phone?.length | 0}/100
                    </p>
                  </div>
                  <div className="flex flex-col items-start ps-4 text-center md:text-left">
                    <div className="flex items-center w-full">
                      <input id="contactMe" name="contactMe" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" checked={dataForm?.contactMe} disabled={!(dataForm.name && validateEmail(dataForm.email) || dataForm.name && dataForm.phone)} onChange={el => setDataForm({
                    ...dataForm,
                    contactMe: el.currentTarget.checked
                  })} />
                      <label htmlFor="contactMe" className="w-full py-4 ms-2 text-sm font-medium text-gray-900 ">
                        Ich möchte zu meinem Feedback persönlich kontaktiert werden.
                      </label>
                    </div>
                    <div className="flex items-center w-full">
                      <input id="useMyData" name="useMyData" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" checked={dataForm?.useMyData} disabled={!(dataForm.name && validateEmail(dataForm.email) || dataForm.name && dataForm.phone)} onChange={el => setDataForm({
                    ...dataForm,
                    useMyData: el.currentTarget.checked
                  })} />
                      <label htmlFor="useMyData" className="w-full py-4 ms-2 text-sm font-medium text-gray-900">
                        Mein Feedback darf für Marketingzwecke der GSP Network GmbH verwendet werden.
                        (Als Dankeschön wird ein zusätzlicher Support-Key an die angegebene E-Mail-Adresse gesendet).
                      </label>
                    </div>

                  </div>
                  <br></br>
                  <div className="ps-4 border border-gray-200 rounded dark:border-gray-700">
                    <div className="flex items-center w-full">
                      <input id="dsgvo" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" checked={dsgvo} onChange={() => setDsgvo(!dsgvo)} />
                      <label htmlFor="dsgvo" className="w-full py-4 ms-2 text-sm font-medium text-gray-900">
                        Ich stimme der Nutzung meiner Daten zu. <a href="https://gsp-network.com/datenschutz/" target="_blank" className="hover:underline me-4 md:me-6">(Datenschutzbestimmungen ansehen)</a>
                      </label>
                    </div>
                    {!(dataForm.name && validateEmail(dataForm.email) && dsgvo || !dataForm.name && !validateEmail(dataForm.email) && !dsgvo) && <p className="text-red-700 text-xs">Bitte den Namen und die E-Mail Adresse eingeben und den Datenschutzbestimmungen zustimmen!</p>}
                  </div>

                  <div className="flex justify-between pt-10">
                    <button onClick={handlePrev} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm  sm:px-8 bg-[#083d78] hover:bg-[#de782d]`}>
                      zurück
                    </button>
                    <button type="submit"
                // onClick={handleSubmit}
                disabled={!(dataForm.name && validateEmail(dataForm.email) && dsgvo || !dataForm.name && !validateEmail(dataForm.email) && !dsgvo)} className={`flex items-center justify-center border border-transparent px-4 py-3 text-base font-medium text-white shadow-sm sm:px-8 ${!(dataForm.name && validateEmail(dataForm.email) && dsgvo || !dataForm.name && !validateEmail(dataForm.email) && !dsgvo) ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#083d78] hover:bg-[#de782d]'}`}>
                      Feedback absenden
                    </button>
                  </div>
                </div>}
            </Form>
          </div>
        </div>
      </div>

    </div>;
}
_s(FeedbackPage, "0HzpEBN9Ov6BY1PCzklMLxy71po=", false, function () {
  return [useLoaderData, useActionData, useSubmit];
});
_c = FeedbackPage;
var _c;
$RefreshReg$(_c, "FeedbackPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;